import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { log } from '@atlassian/mpac-utils';
import invariant from 'invariant';
import { fullPercentage } from '../../utils/numberFormatting.utils';
import { countKey, REPORTS_CONTENT_WIDTH } from './PartnerReports.constants';
export const getElements = (series, name) => {
  var _series$find$elements, _series$find;
  return (_series$find$elements = (_series$find = series.find(item => item.name === name)) === null || _series$find === void 0 ? void 0 : _series$find.elements) !== null && _series$find$elements !== void 0 ? _series$find$elements : [];
};
export const getSeries = (series, name) => {
  var _series$find$series, _series$find2;
  return (_series$find$series = (_series$find2 = series.find(item => item.name === name)) === null || _series$find2 === void 0 ? void 0 : _series$find2.series) !== null && _series$find$series !== void 0 ? _series$find$series : [];
};
export const calculateRate = function calculateRate() {
  let total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let actual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return parseFloat(fullPercentage(actual / total));
};

/* This will format the given series as the data needed to render Line Chart
 * for ex: give input [[{ xLabel: date1, hosting: {} } ...], [{ xLabel: date1, server: {} } ...]]
 * output would be [{ xLabel: date1, hosting: {}, server: {} }]
 */
export const formatChartData = toBeFormatted => toBeFormatted.reduce((prevSeries, currentSeries) => prevSeries.map((formattedSeriesWithXLabel, index) => _objectSpread(_objectSpread({}, currentSeries[index]), formattedSeriesWithXLabel)));
export const mapToReportingAppsFilterOptions = reportingApps => reportingApps.map(app => ({
  appId: app.appId,
  label: app.appName,
  value: app.appKey
}));
export const getReportsContainerWidth = () => REPORTS_CONTENT_WIDTH;
export const sortReportData = function sortReportData(summary, reportName) {
  return reportName !== 'feedback' ? summary : summary.sort((a, b) => {
    var _a$content, _a$content$props, _b$content, _b$content$props;
    /**
     * This has been done to not move All {reportName} and let it be at the last position
     * as there might be cases where one of the Report Parameters is the only contribution
     * to the total which can result in making it second card in the overview component.
     */
    if (a.head === "All ".concat(reportName)) return 1;
    if (b.head === "All ".concat(reportName)) return -1;
    /**
     * This is the normal Sort Function which depicts the sorting is being done based on the Count
     * of the report parameter
     */
    return ((a === null || a === void 0 ? void 0 : (_a$content = a.content) === null || _a$content === void 0 ? void 0 : (_a$content$props = _a$content.props) === null || _a$content$props === void 0 ? void 0 : _a$content$props[countKey[reportName]]) || 0) > ((b === null || b === void 0 ? void 0 : (_b$content = b.content) === null || _b$content === void 0 ? void 0 : (_b$content$props = _b$content.props) === null || _b$content$props === void 0 ? void 0 : _b$content$props[countKey[reportName]]) || 0) ? -1 : 1;
  });
};
export const handleInvariant = (location, testValue, message) => {
  try {
    invariant(testValue, message);
  } catch (err) {
    log.error(location, err.message, err);
    throw err;
  }
};